import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core'
import { SortDirection } from '@ftr/contracts/api/shared'
import { Icon, IconComponent } from '@ftr/foundation'

/* Component alignment options:
 *   - 'justify' to preserve width when switching between 'asc' and 'desc'.
 *   Use when this component is displayed inline.
 *   - 'start' to pack items from the start.
 *   Use when this component doesn't have a neighbor on the right.
 * */
export type SortDirectionAlign = 'justify' | 'start'
export interface SortDirectionText {
  ascending: string
  descending: string
}
export const sortDirectionComponentTestIds = {
  button: 'sort-direction-button',
  text: 'sort-direction-text',
}
@Component({
  selector: 'ftr-sort-direction',
  templateUrl: './sort-direction.component.html',
  styleUrls: ['./sort-direction.component.css'],
  standalone: true,
  imports: [CommonModule, IconComponent],
})
export class SortDirectionComponent implements OnInit {
  protected readonly testIds = sortDirectionComponentTestIds
  @Input() default: SortDirection = SortDirection.Descending
  @Input() label: string = 'Sort:'
  @Input() align: SortDirectionAlign = 'justify'
  @Input() currentValue?: SortDirection
  /* Optional template for customization */
  @Input() sortByTemplate: TemplateRef<any>
  @Input() sortDirectionText?: SortDirectionText | undefined
  @Input() invertIconDirection: boolean = false
  @Output() onSelectionChange = new EventEmitter<SortDirection>()

  readonly sortDirection = SortDirection

  ngOnInit(): void {
    if (!this.currentValue) {
      this.currentValue = this.default
    }
  }

  changeSelection(): void {
    this.currentValue =
      this.currentValue === SortDirection.Ascending ? SortDirection.Descending : SortDirection.Ascending
    this.onSelectionChange.emit(this.currentValue)
  }

  getCurrentValueText(): string {
    if (this.sortDirectionText) {
      return this.currentValue === SortDirection.Ascending
        ? this.sortDirectionText.ascending
        : this.sortDirectionText.descending
    }

    return this.currentValue === SortDirection.Ascending ? 'Ascending' : 'Descending'
  }

  getCurrentValueIcon(): Icon {
    if (this.invertIconDirection) {
      return this.currentValue === SortDirection.Ascending ? 'ChangeOrderDown' : 'ChangeOrderUp'
    }

    return this.currentValue === SortDirection.Ascending ? 'ChangeOrderUp' : 'ChangeOrderDown'
  }
}
